import { parseIframeComponentCore, extractProportions } from './component.iframe.core.js';

const parseIbook4Component = (node) => {
  const bookId = node.getAttribute("bookId");
  const coreConfig = parseIframeComponentCore(node);
  if (!bookId || !coreConfig) {
    return null;
  }
  const displayData = {
    proportions: extractProportions(node.getAttribute("aspectRatio"), {
      width: 16,
      height: 9
    }),
    minSize: {
      width: 640,
      height: 460
    },
    maxSize: extractProportions(node.getAttribute("maxSize"), {
      width: 0,
      height: 0
    }),
    src: `${process.env["IBOG4_URL"]}/${encodeURIComponent(bookId)}/?embed=1`,
    fixedHeight: false
  };
  return {
    ...coreConfig,
    displayData,
    pm2: {
      ...coreConfig.pm2,
      enableNewWindowButton: true
    },
    options: {
      ...coreConfig.options,
      autoActivate: true
    },
    meta: {
      ...coreConfig.meta,
      contentType: "i-book"
    }
  };
};

export { parseIbook4Component };
//# sourceMappingURL=component.iframe.ibook4.js.map
